import { defineStore } from 'pinia'
import { templates, defaultTemplateId } from '~/templates/registry'

import type { ThemeId } from '~/types/portfolio'
export type { ThemeId }

export const useSiteStore = defineStore('site', {
  state: () => ({
    templateId: defaultTemplateId as string,
    theme: 'amber' as ThemeId,
    loaded: false,
    sideMenuOpen: false,
    activeSection: 'hero'
  }),
  getters: {
    templates: () => templates,
    current: (s) => templates.find(t => t.id === s.templateId) ?? templates[1]!
  },
  actions: {
    setTemplate(id: string) {
      const tpl = templates.find(t => t.id === id)
      if (!tpl) return
      this.templateId = id
      // تم قالب قبلی نباید روی قالب جدید بماند
      if (!tpl.themes.includes(this.theme)) this.setTheme(tpl.themes[0]!)
      if (import.meta.client) localStorage.setItem('portify:template', id)
    },
    setTheme(theme: ThemeId) {
      if (!this.current.themes.includes(theme)) return
      this.theme = theme
      if (import.meta.client) {
        document.documentElement.dataset.theme = theme
        localStorage.setItem('portify:theme', theme)
      }
    },
    toggleTheme() {
      const list = this.current.themes
      this.setTheme(list[(list.indexOf(this.theme) + 1) % list.length]!)
    },
    restore() {
      if (!import.meta.client) return
      const t = localStorage.getItem('portify:template')
      const th = localStorage.getItem('portify:theme') as ThemeId | null
      if (t) this.setTemplate(t)
      this.setTheme(th && this.current.themes.includes(th) ? th : this.current.themes[0]!)
    },
    toggleSideMenu() { this.sideMenuOpen = !this.sideMenuOpen },
    closeSideMenu() { this.sideMenuOpen = false },
    markLoaded() { this.loaded = true }
  }
})
